import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { 
  ArrowRight, 
  Zap, 
  Gift, 
  Truck, 
  Clock,
  Sparkles,
  Tag,
  Percent
} from "lucide-react";

const OfferStrip = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });

  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

 {/* const offers = [
    { icon: Gift, text: "25% OFF", color: "from-red-600 to-amber-600" },
    { icon: Truck, text: "FREE SHIPPING", color: "from-blue-600 to-cyan-600" },
    { icon: Zap, text: "WORLDWIDE", color: "from-purple-600 to-pink-600" },
  ];*/}

  return (
    <div className="relative bg-gradient-to-r from-gray-50 via-white to-gray-50 border-y border-gray-200 overflow-hidden">
      
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-60 h-60 bg-gradient-to-br from-red-600/5 to-amber-600/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-gradient-to-br from-blue-600/5 to-purple-600/5 rounded-full blur-3xl"></div>
        
        {/* Moving Dots Pattern */}
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #e5e7eb 1px, transparent 1px)',
          backgroundSize: '30px 30px',
          opacity: 0.3
        }}></div>
      </div>

      {/* Main Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-5">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
          
          {/* Left Section - Offer Icons */}
          {/*<div className="flex items-center gap-4 lg:gap-6">
            {offers.map((offer, index) => {
              const Icon = offer.icon;
              return (
                <div
                  key={index}
                  className="group flex items-center gap-2 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5"
                >
                  <div className={`w-6 h-6 bg-gradient-to-br ${offer.color} rounded-full flex items-center justify-center`}>
                    <Icon className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-gray-900 group-hover:to-gray-700">
                    {offer.text}
                  </span>
                </div>
              );
            })}
          </div>*/}

          {/* Center - Main Offer Text */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-50 to-yellow-50 px-4 py-2 rounded-full border border-amber-200">
              <Sparkles className="w-4 h-4 text-amber-500" />
              <span className="text-xs font-semibold text-amber-700 uppercase tracking-wider">
                Flash Sale
              </span>
            </div>
            
            <div className="mt-2">
              <h3 className="text-sm md:text-base lg:text-lg font-bold">
                <span className="bg-gradient-to-r from-amber-600 to-yellow-600 bg-clip-text text-transparent">
                  WORLD WIDE OFFER AVAILABLE
                </span>
              </h3>
              <p className="text-base md:text-lg lg:text-xl font-extrabold mt-1">
                <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
                  GET 25% OFF OR NEXT DAY FREE SHIPPING
                </span>
              </p>
            </div>
          </div>

          {/* Right Section - CTA Button & Timer */}
          <div className="flex items-center gap-4">
            
            {/* Countdown Timer */}
            <div className="hidden md:flex items-center gap-2">
              <Clock className="w-4 h-4 text-red-600" />
              <div className="flex items-center gap-1 text-sm font-mono">
                <span className="bg-gray-100 px-1.5 py-1 rounded text-gray-800 font-bold">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <span className="text-gray-400">:</span>
                <span className="bg-gray-100 px-1.5 py-1 rounded text-gray-800 font-bold">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <span className="text-gray-400">:</span>
                <span className="bg-gray-100 px-1.5 py-1 rounded text-gray-800 font-bold">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <Link
              to="/shop"
              className="group relative inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-amber-600 hover:from-red-700 hover:to-amber-700 text-white px-6 md:px-8 py-3 rounded-full font-semibold text-sm uppercase tracking-wider transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-red-600/20 overflow-hidden"
            >
              <span className="relative z-10 flex items-center gap-2">
                VIEW PRODUCTS
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
            </Link>
          </div>
        </div>

        {/* Bottom Bar - Additional Info */}
        <div className="mt-3 pt-3 border-t border-gray-100 flex flex-wrap items-center justify-center gap-4 text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <Tag className="w-3 h-3" />
            <span>Limited Time Offer</span>
          </div>
          <div className="flex items-center gap-1">
            <Percent className="w-3 h-3" />
            <span>25% OFF Sitewide</span>
          </div>
          <div className="flex items-center gap-1">
            <Truck className="w-3 h-3" />
            <span>Free Shipping on Orders $100+</span>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute left-1/4 top-1/2 -translate-y-1/2 w-1 h-1 bg-red-600 rounded-full animate-ping hidden lg:block"></div>
      <div className="absolute right-1/4 top-1/2 -translate-y-1/2 w-1 h-1 bg-amber-600 rounded-full animate-ping animation-delay-1000 hidden lg:block"></div>
    </div>
  );
};

export default OfferStrip;